import { Spin, message, Select, Space, Button } from "antd";
import React, { useState } from "react";
import {
  CopyOutlined
} from '@ant-design/icons';

function SelectAccounts(props) {
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const options = [{
    label: 'Tất Cả',
    value: 'all'
  }];
  if(props.selectAccounts) {
    props.selectAccounts.forEach(account => {
      options.push({
        label: `ID: ${account.id} - ${account.name}`,
        value: account.id
      })
    })
  }

  const handleChange = (values) => {
    if (values.includes('all')) {
      let selects = options.filter(v => v.value !== 'all').map(v => v.value)
      props.onSelected(selects);
      setSelectedItems(selects);
    } else {
      props.onSelected(values);
      setSelectedItems(values);
    }

  };
  const oncopy = (option, e) => {
    navigator.clipboard.writeText(option.label);
    messageApi.info(`Đã copy: ${option.label}`);
  }

  return (
    <>
      {contextHolder}
      {loading && <Spin />}
      <Space
        style={{
          width: "100%",
        }}
        direction="vertical"
      >
        <label><b>Chọn MCC:</b> {selectedItems.length>0 && <span>{selectedItems.length}</span>}</label>
        <Select
          mode={"multiple"}
          maxCount={props.max || 100}
          value={selectedItems}
          allowClear
          style={{
            width: "100%",
            maxWidth: "350px"
          }}
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          placeholder="Chọn MCC..."
          onChange={handleChange}
          options={options}
          optionRender={option => (
            <Space>
              {option.data.label}
              <Button size="small" onClick={(e) => oncopy(option.data, e)}><CopyOutlined /></Button>
            </Space>
          )}
        />
        {/* todo: add select All */}
      </Space>
    </>
  );
}
export default SelectAccounts;
